import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, Observable } from 'rxjs';
import { SessionDraft, SessionStore } from '../../../state';
import { toSessionDraftViewModel } from '../../../mappers';
import { SessionDraftQueryResult } from './session-draft.query-result';

export class SessionDraftQueryHandler {
  private readonly store: SessionStore = inject(SessionStore);

  query(): Observable<SessionDraftQueryResult | null> {
    return toObservable(this.store.draft).pipe(
      map((d: SessionDraft | null) => (d === null ? null : { draft: toSessionDraftViewModel(d) }))
    );
  }
}
